// Import produktet nga file-t e ndara sipas kategorive
import { productsCouple } from './productsCouple';
import { productsTravel } from './productsTravel';
import { productsBaby } from './productsBaby';
import { productsFrame } from './productsFrame';

// Kombinimi i produkteve me renditje të saktë:
// 1. Produktet për Love and Couple (wedding)
// 2. Produktet për Travel Book
// 3. Produktet për Baby Book
// 4. Produktet për Frame
export const products = [
  ...productsTravel,  // Te gjitha produktet per Love and Travel Book
  ...productsCouple,  // Te gjitha produktet per Couple Book
  ...productsBaby,    // Te gjitha produktet per Baby Book
  ...productsFrame    // Te gjitha produktet per Frame
];

export const templates = [
  {
    id: 1,
    name: "Template Klasik",
    thumbnail: "🌸",
    description: "Dizajn i thjeshtë dhe elegant"
  },
  {
    id: 2,
    name: "Template Modern",
    thumbnail: "✨",
    description: "Dizajn bashkëkohor dhe dinamik"
  },
  {
    id: 3,
    name: "Template Vintage",
    thumbnail: "🎨",
    description: "Stil retro dhe nostalgik"
  },
  {
    id: 4,
    name: "Template Minimal",
    thumbnail: "⭐",
    description: "Thjeshtësi dhe elegancë"
  },
  {
    id: 5,
    name: "Template Colorful",
    thumbnail: "🌈",
    description: "Ngjyra të gjalla dhe të bukura"
  },
  {
    id: 6,
    name: "Template Nature",
    thumbnail: "🌿",
    description: "Frymëzuar nga natyra"
  }
];

export const pageOptions = [
  { pages: 50, price: 24.90, label: "50 deri 75 Foto", labelKey: "pageOption.50to75", minPhotos: 50, maxPhotos: 75 },
  { pages: 100, price: 34.90, label: "75 deri 150 Foto", labelKey: "pageOption.75to150", minPhotos: 75, maxPhotos: 150 }
];
